import React from 'react'
import ContenedorInput from '../common/ContenedorInput'
export default function ContenedorInputRM(props) {
    return (
        <ContenedorInput md="6" sm="6" col="12" {...props}>
            {props.children}
        </ContenedorInput>
    )
}
